import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import 'bootstrap/dist/css/bootstrap.min.css';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import RegistrationModal from '../components/RegistrationModal';

export default function InvitationAccept() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [invitationId, setInvitationId] = useState(null);
  const [familyId, setFamilyId] = useState("");
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);

  // URLクエリパラメータから招待情報を取得し、招待情報を取得
  useEffect(() => {
    // 無効URL画面に遷移
    const navigateToInvalid = (errorMessage) => {
      navigate('/Invalid', { state: { errorMessage } });
    };

    const params = new URLSearchParams(window.location.search);
    const invitationIdParam = params.get("InvitationID") || "";
    
    setInvitationId(invitationIdParam);
    
    const db = firebase.firestore();
    if (invitationIdParam) {
      // URLパラメータから招待IDを取得
      // InvitationID=(InvitationID) の形式でアクセスされた場合
      
      // 正しいコレクション構造:
      // Invitation/(InvitationID)
      // 招待IDから招待情報を取得する
      
      db.collection("Invitation").doc(invitationIdParam)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data();
            // 招待が有効かチェック (Active=true, Completion=false, 有効期限内)
            if (data.Active && !data.Completion && data.Expiration && data.Expiration.toDate() > new Date()) {
              // メールアドレスと家族IDを設定
              setEmail(data.Invitation_Email);
              setFamilyId(data.FamilyID || "");
              setLoading(false);
            } else {
              // 無効な招待の場合
              console.error("Invalid invitation");
              navigateToInvalid("本URLは無効です。");
            }
          } else {
            console.error("Invitation not found");
            navigateToInvalid("本URLは無効です。");
          }
        })
        .catch((error) => {
          console.error("Error getting invitation: ", error);
          navigateToInvalid("本URLは無効です。");
        });
    } else {
      // InvitationIDパラメータがない場合は無効URLとして扱う
      console.error("InvitationID parameter is missing");
      navigateToInvalid("本URLは無効です。");
    }
  }, [navigate]);

  // 新規会員登録ボタンのクリックハンドラ
  const handleRegisterClick = () => {
    // 会員登録モーダルを表示
    setShowRegistrationModal(true);
  };

  // 登録完了時のハンドラ
  const handleRegistrationComplete = () => {
    // 登録完了後、ログイン画面に遷移
    navigate('/Login');
  };

  return (
    <React.Fragment>
      <Grid container direction="column" spacing={2} style={{ padding: '16px' }}>
        {/* 1. タイトル */}
        <Grid item xs={12}>
          <Typography variant="h5" style={{ marginBottom: '16px', fontWeight: 'bold' }}>
            家族・関係者と情報共有しましょう
          </Typography>
        </Grid>
        
        {/* 2. 家族招待の概要 */}
        <Grid item xs={12}>
          <Typography variant="body1" style={{ marginBottom: '24px' }}>
            ご家族の健康状態を把握して、誰でも対応できるように
          </Typography>
        </Grid>
        
        {loading ? (
          // ローディング表示
          <Grid item xs={12} style={{ textAlign: 'center', padding: '32px' }}>
            <Typography>読み込み中...</Typography>
          </Grid>
        ) : (
          <>
            {/* 3. アプリ機能紹介 */}
            <Grid item xs={12}>
              <Paper 
                elevation={0} 
                style={{ 
                  backgroundColor: '#FFF9E0', 
                  padding: '24px 16px', 
                  marginBottom: '32px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
              >
                <Typography variant="h6" style={{ marginBottom: '16px' }}>
                  ふぁみかるくんってなに？
                </Typography>
                <Typography 
                  variant="body1"
                  style={{
                    lineHeight: '1.6',
                    // overflowWrap: 'break-word',
                    fontSize: window.innerWidth <= 360 ? '0.75rem' : 
                             window.innerWidth <= 480 ? '0.8rem' : '1rem',
                  }}
                >
                  ふぁみかるくんは、ご家族の健康情報を共有し、<br />
                  家族全員で健康管理をサポートするアプリです。<br />
                  診察記録や服薬情報を家族間で共有することで、<br />
                  離れていても家族の健康状態を把握できます。
                </Typography>
              </Paper>
            </Grid>
            
            {/* 4. 新規会員登録ボタン */}
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <Button 
                variant="contained" 
                color="primary" 
                size="large"
                style={{ 
                  padding: '12px 32px',
                  fontSize: '16px'
                }}
                onClick={handleRegisterClick}
              >
                新規会員登録
              </Button>
            </Grid>
          </>
        )}
      </Grid>

      {/* 会員登録モーダル */}
      <RegistrationModal
        show={showRegistrationModal}
        onHide={() => setShowRegistrationModal(false)}
        email={email}
        isInvitation={true}
        invitationId={invitationId}
        familyId={familyId}
        onRegistrationComplete={handleRegistrationComplete}
      />
    </React.Fragment>
  );
}
